const baseUrl = process.env.NEXT_PUBLIC_BASE_URL

export const getPanel = async ({ slug, localeValue, language, limit, page }) => {



    const url = `${baseUrl}/content/search/${slug}?page=${page}&limit=${limit}`
    const headers = {
        'apikey': process.env.NEXT_PUBLIC_RSTBASE_API_KEY,
        'locale': localeValue || 'en'
    }

    const response = await fetch(url, {
        headers: headers,
        // cache: 'no-store'
        next: { revalidate: 1800 } // 30m
    })

    const result = await response.json()

    // console.log(result)
    
    return result

}